import { useState } from "react";
import SideNav from "./SideNav";

export const SidebarLayout = ({ children, sideNavPosition, mainBodyStyle }) => {
  const [toggle, setToggle] = useState(false);

  return (
    <>
      {/* Side Navigation */}
      <div className="side-nav-bar" style={{ display: toggle ? "block" : "none" }}>
        <SideNav position={sideNavPosition} />
      </div>

      {/* Main Body */}
      {/* Merging default style with any custom style passed via prop */}
      <div className="main-body" style={{ backgroundColor: "#FAFAFC", ...mainBodyStyle }}>
        <div className="toggle-btn">
          <button className="btn btn-light" onClick={() => setToggle(!toggle)}>
            <i className="fa fa-align-justify" aria-hidden="true"></i>
          </button>
        </div>
        {children}
      </div>
    </>
  );
};